
export default "/assets/h3-micro.341da9a9.svg"